import { FC, lazy } from "react";
import { privateRoutesListODoctor } from "./RoutesListODoctor";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import AuthLayout from "../layout/AuthLayout";
import { useLocation } from "react-router-dom";
import Register from "app/components/pages/register";

const NotFound = lazy(() => import("../app/components/pages/notFound/NotFound"));
const Login = lazy(() => import("../app/components/pages/loginODoctor/Login"));

const RoutesComponent: FC = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="/" element={<MainLayout />}>
          {privateRoutesListODoctor.map(({ Component, path, children }, index: number) => (
            <Route key={index} element={Component} path={path}>
              {children && children.map((item, index) => <Route key={index} element={item.Component} path={item.path} />)}
            </Route>
          ))}
        </Route>
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export { RoutesComponent };
